import { fetchAdminV1 } from "../lib/requester/v1";

export function getAll(params) {
	return fetchAdminV1("/industries", { method: "GET", data: params }, { returnWholeResponse: true });
}

export function getIndustry(id) {
	return fetchAdminV1(`/industries/${id}`, { method: "GET" });
}

export function update(data) {
	return fetchAdminV1(`/industries/${data.id}`, { method: "PUT", data });
}

export function remove(data) {
	return fetchAdminV1(`/industries/${data.id}`, { method: "DELETE" });
}

export function create(data) {
	return fetchAdminV1(`/industries`, { method: "POST", data });
}
